import { IdbOutboxStore, openIdbOutboxDb } from '../../../lib/outbox/idb';
import type { RecipePhotoOutboxRecord } from './store';

export const OUTBOX_DB_NAME = 'awwyeah-recipes-outbox';
export const OUTBOX_DB_VERSION = 1;
export const PHOTO_STORE = 'photos';

export interface RecipeOutboxStores {
  photos: IdbOutboxStore<RecipePhotoOutboxRecord>;
}

/** Opens the recipe photo outbox store, or `null` when IndexedDB is unusable (private
 * mode, denied) — same fallback posture as check-in's outbox. */
export async function openRecipeOutboxStores(
  factory: IDBFactory | undefined = typeof indexedDB === 'undefined' ? undefined : indexedDB,
): Promise<RecipeOutboxStores | null> {
  if (!factory) return null;
  try {
    const db = openIdbOutboxDb(factory, OUTBOX_DB_NAME, OUTBOX_DB_VERSION, [PHOTO_STORE]);
    await db;
    return { photos: new IdbOutboxStore(PHOTO_STORE, db) };
  } catch (error) {
    console.warn(
      '[recipes] IndexedDB unavailable — a queued photo will only survive this session',
      error,
    );
    return null;
  }
}
